var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-link',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-sm",attrs:{"to":{ name: 'gateways_details', params: { hashid: _vm.row.id, gateway_source : 'starshop-gateways' }}}},[_c('i',{staticClass:"fa fa-eye"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }